import React from "react";
import { observer } from "mobx-react";

import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { useRootAppStore } from "@hooks";
import { BetBuilderPicksOfferTips } from "./BetBuilderPicksOfferTips";
import BetBuilderPicksQuotaButton from "./BetBuilderPicksQuotaButton";
import { QuickPlayCardsTeams } from "../../common/QuickPlayCardsTeams";

export default observer(function BetBuilderPicksCard(props: {
	BBPick: BetBuilderPick;
	maxOffers?: number;
	isPopup?: boolean;
}) {
	const rootStore = useRootAppStore();

	const isFaded =
		props.maxOffers && props.BBPick.multiOffers.length > props.maxOffers;

	return (
		<>
			<div className="card--qp__event card--bbp__event">
				<QuickPlayCardsTeams
					sportData={props.BBPick.multiOffers[0].sportData}
					teamNameClassName="card--bbp__team card--bbp--nowrap__team"
				/>
			</div>

			<div className="card--qp__offer card--bbp__offer">
				<BetBuilderPicksOfferTips
					multiOffers={props.BBPick.multiOffers}
					maxOffers={props.maxOffers}
				/>

				{isFaded && <div className="card--qp__more card--bbp__more" />}
			</div>

			<BetBuilderPicksQuotaButton
				BBPick={props.BBPick}
				store={rootStore.quickPlayStore.betBuilderPicksStore}
			/>
		</>
	);
});
